import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import api from '../../services/api';
import { PRIORIDADES, PRIORIDAD } from '../../utils/prioridad';

// Prioridad del pedido (25-oct-2026), solo admin: decide qué entra primero al armar el día.
// Sale sola del motivo; tocando otra queda fija (con una nota, ej. "cliente enojado"). "Automática" la
// devuelve a la del motivo. Es interna: a la empresa no le llega.
export default function PrioridadPedido({ pedido, onCambio }) {
    const [nota, setNota] = useState(pedido.prioridadNota || '');
    const [guardando, setGuardando] = useState(false);
    const guardar = async (prioridad, n = nota) => {
        setGuardando(true);
        try {
            const r = await api.post(`/pedidos-empresa/${pedido.id}/prioridad`, { prioridad, nota: n || null });
            onCambio(r.data);
            if (!prioridad) setNota('');
        } catch (e) { toast.error(e?.response?.data?.mensaje || 'No se pudo guardar'); }
        finally { setGuardando(false); }
    };
    const actual = PRIORIDAD[pedido.prioridad];
    return (
        <div className="rounded-2xl bg-panel p-4 space-y-2.5">
            <div className="flex items-baseline justify-between gap-2">
                <span className="text-label font-black uppercase tracking-widest text-muted">Prioridad</span>
                <span className="text-caption text-muted">{pedido.prioridadManual ? 'puesta a mano' : 'por el motivo'}</span>
            </div>
            <div className="grid grid-cols-4 gap-1.5">
                {PRIORIDADES.map(x => {
                    const activo = pedido.prioridad === x.id;
                    return (
                        <button key={x.id} type="button" disabled={guardando} aria-pressed={activo}
                            onClick={() => !activo && guardar(x.id)}
                            className={`h-10 rounded-xl text-label font-black active:scale-95 disabled:opacity-60 ${activo ? x.clase : 'bg-card text-secondary border border-black/[0.06] dark:border-white/[0.06]'}`}>
                            {x.label}
                        </button>
                    );
                })}
            </div>
            {actual && <p className="text-caption text-muted">{actual.ayuda}</p>}
            {pedido.prioridadManual && (
                <div className="flex gap-2">
                    <input value={nota} onChange={e => setNota(e.target.value)} maxLength={120} placeholder="Por qué (ej. cliente enojado)"
                        onBlur={() => nota !== (pedido.prioridadNota || '') && guardar(pedido.prioridad)}
                        className="flex-1 min-w-0 h-10 px-3 rounded-xl bg-card text-body text-ink outline-none border border-black/[0.06] dark:border-white/[0.06]" />
                    <button type="button" disabled={guardando} onClick={() => guardar(null, '')}
                        className="h-10 px-3 rounded-xl bg-chip text-secondary text-label font-black shrink-0">Automática</button>
                </div>
            )}
        </div>
    );
}
